import NamePlateModal from './name-plate-modal.view';

export default NamePlateModal;
